import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDetails = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16 16",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M6.5,2H2C1.4,2,1,2.4,1,3v11c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1H9.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M9.5,2.5C9.5,1.7,8.8,1,8,1S6.5,1.7,6.5,2.5v1C6.5,3.8,6.7,4,7,4h2c0.3,0,0.5-0.2,0.5-0.5V2.5 z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			cx: 8,
			cy: 8.2,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M12,15c-0.3-2.2-2.3-3.8-4.5-3.5C5.7,11.8,4.2,13.2,4,15"
		})
	] })
});
export { SvgIconDetails as ReactComponent };
